const React = require("react");
const {default: FormControl} = require("@material-ui/core/FormControl");
const {default: Select} = require("@material-ui/core/Select");
const Arrow = require("./svg/ArrowBase");

const selectCtor = require('../../utils/selectCtor');
const ErrorDisplay = require('../ErrorDisplay');
const LabelDisplay = require('../LabelDisplay');

const SelectWrapper = ({children, className, showError, disabled}) => (
  <div className={`
      w rlv f14>.MuiSelect-root o50.disabled
      (pv13|ph25|c0-i)>.MuiOutlinedInput-input
      pr60>.MuiOutlinedInput-input*2
      (bgF|ph5|f12|ff$3|fw3)>.MuiFormLabel-root
      (c0-i)>.MuiFormLabel-root:not[.Mui-error]
      (x20y17s100|x20y16s100@firefox)>.MuiInputLabel-formControl
      x20y-6s100(|@firefox)>.MuiInputLabel-outlined.MuiInputLabel-shrink
      bgF>.MuiSelect-select:focus
      (b1-i|olN|r9)>.*-notchedOutline
      (bc8)>:not[.Mui-error]>.*-notchedOutline
      (bc0)>.Mui-focused:not[.Mui-error]>.*-notchedOutline
      dn>.*-notchedOutline 
    `
    + (disabled ? ' disabled' : '')
    + (showError ? ' error' : '')
    + (className ? ` ${className}` : '')
  }>
    {children}
  </div>
);

const SelectDisplay = ({id, value, name, itemsDisplay, onChange, testId, disabled}) => (
  <Select
    id={id}
    className="w"
    value={value || ''}
    onChange={(e) => onChange(name, e.target.value)}
    IconComponent={Arrow}
    disabled={disabled}
    data-testid={testId}
  >
    {itemsDisplay}
  </Select>
);

const Component = ({
  className,
  labelProps = {},
  selectProps = {},
  errorProps = {}
}) => (
  <SelectWrapper
    className={className}
    showErroу={errorProps.showError}
    disabled={selectProps.disabled}
  >
    <LabelDisplay {...labelProps} />
    <FormControl className="w" variant="outlined">
      <SelectDisplay {...selectProps} />
    </FormControl>
    <ErrorDisplay {...errorProps} />
  </SelectWrapper>
);



module.exports = selectCtor(Component);
